/**
 * The version stamp every unified /apply row carries in `answers.form_version`,
 * and the same value every apply analytics event carries as `form_version`. It
 * is what tells a unified row from a historical one, so it changes whenever the
 * step ids or the step order change.
 *
 * It lives in its own module, with nothing else in it, because the site-wide
 * analytics module (`web/lib/analytics.ts`) needs this one string and loads on
 * every marketing page. Importing it from `web/lib/coaching/application.ts`
 * would ship the whole application question set, built at load time, to pages
 * that never show the form. The application module re-exports it, so every
 * reader of the form keeps one import.
 */
export const APPLICATION_FORM_VERSION = "unified-1"
